import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "./LanguageContext";
import gameImage from "../Images/fact-or-fake.png";
import descriptions from "./minigameDescriptions.json";

export default function InteractiveLab() {
  const { selectedLanguage } = useContext(LanguageContext);
  const en = selectedLanguage === "en";
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main style={{ borderTop: "1px solid black", marginTop: "1.5rem" }}>
      <div style={{ maxWidth: "1024px", margin: "auto", padding: "40px 24px" }}>
        <nav aria-label="Breadcrumb" style={{ marginBottom: "40px" }}>
          <Link to="/Tools-and-Services" style={{ color: "#AE023E" }}>Tools</Link>
          <span> › Fact or Fake</span>
        </nav>
        <h2 style={{ color: "#AE023E", fontFamily: "MyFont" }}>
          {en ? "Fact or Fake?" : "Fact or Fake? : เกมทดสอบข่าวจริง–ข่าวปลอม"}
        </h2>
        <div className="row mt-4">
          <div className="col-md-5 mb-4">
            <img src={gameImage} alt={en ? "Fact or Fake game instructions" : "วิธีเล่นเกมข่าวจริง–ข่าวปลอม"}
              style={{ width: "100%", height: "auto", borderRadius: "8px" }} />
          </div>
          <div className="col-md-7" style={{ textAlign: "left" }}>
            <h3>{en ? "About the game" : "เกี่ยวกับเกม"}</h3>
                        {descriptions.fact[en ? "en" : "th"].map((paragraph, index) => <p key={index}>{paragraph}</p>)}
<a href={`${process.env.PUBLIC_URL}/games/fact-or-fake/index.html`}
              target="_blank" rel="noopener noreferrer" className="btn mt-3"
              style={{ background: "#AE023E", color: "white", padding: "12px 24px" }}>
              {en ? "Play game ↗" : "เริ่มเล่นเกม ↗"}
            </a>
            <p className="mt-3" style={{ color: "#555", fontSize: "14px" }}>
              {en ? "Opens in a new tab. The first load may take a moment." : "เกมจะเปิดในแท็บใหม่ การโหลดครั้งแรกอาจใช้เวลาสักครู่"}
            </p>
          </div>
        </div>
              <section aria-labelledby="simulation-title" style={{ marginTop: "48px", textAlign: "left" }}>
          <h2 id="simulation-title" style={{ color: "#AE023E", fontFamily: "MyFont" }}>
            {en ? "Social Media Safety Simulation" : "Social Media Safety Simulation : เกมจำลองสถานการณ์ความปลอดภัยบนสื่อสังคมออนไลน์"}
          </h2>
          {descriptions.simulation[en ? "en" : "th"].map((paragraph, index) => <p key={index}>{paragraph}</p>)}
        </section>
</div>
    </main>
  );
}